import React from 'react'
import { Dialog, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core'
import Controls from "../controls/Controls";
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
        //position: 'absolute',
        //top: theme.spacing(5)
    },
    dialogTitle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: green[600]
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}))

export default function SuccessDialog(props) {

    const { successDialog, setSuccessDialog } = props;
    const classes = useStyles()

    return (
        <Dialog open={successDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h5" className={classes.dialogTitle}>
                    {successDialog.title}
                </Typography>
                <Typography variant="subtitle2">
                    {successDialog.subTitle}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.ActionButton
                    text="Continue"
                    style={{backgroundColor: green[600]}}
                    onClick={() => setSuccessDialog({ ...successDialog, isOpen: false })} />
            </DialogActions>
        </Dialog>
    )
}
